import { render, staticRenderFns } from "./ActionCambio3x3.vue?vue&type=template&id=640c3946&lang=pug"
import script from "./ActionCambio3x3.vue?vue&type=script&lang=js"
export * from "./ActionCambio3x3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports